import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import {currentUserStore} from '../../../../../api/user';
import CheckIcon from '../../../../../assets/icons/check.svg';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {task, user} = contexts;

  return {
    avatar: user?.avatar,
    avatarPlaceholder: user?.name,
    icon: CheckIcon,
    iconGradient: 'success',
    title: i18n.t('notifications:task_done.title', {
      taskTitle: task?.title,
      userName:
        user?._id !== currentUserStore.user?._id
          ? user?.name
          : i18n.t('shared:label.you'),
    }),
  };
};
